var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBbMais(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 374,
    height: 119,
    viewBox: "-1 106 374 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7207_2802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.609 171.458C229.158 170.902 227.775 170.421 226.315 169.865C222.65 168.555 218.706 166.9 214.351 165.038C208.475 162.346 205.57 159.381 205.57 155.926C205.57 151.099 208.475 148.61 214.351 148.61H232.961V137.15H212.14C195.192 137.15 186.756 143.434 186.756 155.926C186.756 161.654 189.661 166.349 195.537 170.148L211.724 177.808C217.601 180.57 220.506 183.469 220.506 186.576C220.506 189.268 219.816 191.545 218.366 193.34C216.84 195.136 214.837 196.032 212.14 196.032H187.994V206.733H213.661C221.752 206.733 227.633 205.762 231.298 203.763C236.697 200.935 239.39 195 239.39 185.958C239.39 179.953 236.419 175.116 230.609 171.463V171.458Z",
    fill: "#0053A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.252 137.146H162.893V206.728H180.252V137.146Z",
    fill: "#0053A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.237 137.146H117.997L98.0781 206.728H115.234L119.452 191.748H137.231L141.175 206.728H159.71L138.681 137.146H128.237ZM128.237 181.325H121.667L127.273 151.783H127.477V152.197L128.237 155.092L134.808 181.325H128.237Z",
    fill: "#0053A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7185 179.878H45.3073L34.5144 123.273H0V206.733H20.8209V141.289H21.2321L34.5144 206.733H55.1982L69.6522 141.289H69.9971V206.733H90.818V123.273H57.409L45.7185 179.878Z",
    fill: "#0053A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372 106.602H254.967V223.399H372V106.602Z",
    fill: "#FFE400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.648 162.112L309.298 146.293L299.054 139.52L312.243 130.598L340.337 149.519L294.875 180.213L304.444 186.638L351.36 155.242L360.8 148.928L351.36 142.596L313.499 117.205L275.611 142.498L265.861 149.011L275.611 155.467L285.648 162.112Z",
    fill: "#0053A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.518 193.27L265.645 199.924L265.742 212.8L275.611 206.287L285.276 199.915L275.611 193.336L275.518 193.27Z",
    fill: "#0053A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.142 167.615L317.492 183.434L327.741 190.208L314.547 199.13L286.457 180.213L331.919 149.514L322.355 143.09L275.611 174.455L265.95 180.941L275.611 187.41L313.123 212.522L351.36 187.088L360.937 180.716L351.36 174.379L341.142 167.615Z",
    fill: "#0053A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.36 124.054L341.925 130.293L351.36 136.749L351.718 136.996L361.304 130.602L361.326 117.461L351.36 124.054Z",
    fill: "#0053A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7207_2802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 372,
    height: 116.797,
    fill: "white",
    transform: "translate(0 106.602)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbMais);
export default __webpack_public_path__ + "static/media/bb-mais.8550dd0f5dc5e1b124a81418fe4e9368.svg";
export { ForwardRef as ReactComponent };